import { M2_MODULES } from 'utils/constants.js'

export function connectorDisplayName(moduleInfo, connectorName) {
  if (M2_MODULES.hasOwnProperty(moduleInfo.value)) {
    // The connector name in M2's doesn't match the label on the module, e.g. C1C for B1.
    // We have to preserve this discrepancy, per product team: just display a generic number.
    const numbers = connectorName.match(/[1-9]/g)
    return numbers ? numbers[numbers.length - 1] : connectorName
  }
  return connectorName
}

export function plural(count) {
  return count == 1 || count == 'one' ? '' : 's' // eslint-disable-line eqeqeq
}
